// Hàm chuyển từ thập phân sang DMS
export function decimalToDMS(
      decimal?: any,
      directionPositive?: any,
      directionNegative?: any
)
{
      const degrees = Math.floor(Math.abs(decimal));
      const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
      const minutes = Math.floor(minutesDecimal);
      const seconds = Math.round((minutesDecimal - minutes) * 60);

      const direction = decimal >= 0 ? directionPositive : directionNegative;
      return `${degrees}° ${minutes}′ ${seconds}″ ${direction}`;
}